import { ActivityDTORead } from "../models/ActivityDTO";
import { ApiResult } from "../models/ApiResult";
import { ApiRequest } from "./service.base";


export class ActivityRequest  extends ApiRequest<ActivityDTORead,ApiResult> {
    constructor(endpoint: string, token: string) {
        super(endpoint, token)
    }
}